import { useField } from "formik";
import { Label } from "@/components/base/Label.tsx";
import { Checkbox, CheckboxProps } from "@/components/base/Checkbox.tsx";
import { Error } from "@/components/base/Error.tsx";

interface FormikCheckboxProps extends CheckboxProps {
  label: string;
  name: string;
}

export const FormikCheckbox = ({ ...props }: FormikCheckboxProps) => {
  const [field, meta, helpers] = useField(props.name);
  const { label } = props;
  return (
    <div className={"align-middle flex flex-row gap-4 "}>
      {label && <Label htmlFor={props.id}>{label}</Label>}
      <Checkbox
        {...field}
        {...props}
        onCheckedChange={(checked) => helpers.setValue(checked)}
      />
      {meta.touched && meta.error ? <Error error={meta.error} /> : null}
    </div>
  );
};
